class SsAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('details');
    this.accordionItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        // Only close other accordions if this one is being opened (not already open)
        if (!item.hasAttribute('open')) {
          this.accordionItems.forEach((el) => {
            if (el !== item) {
              el.removeAttribute('open');
            }
          });
        }
      });
    });
  }
}
customElements.define('ss-accordion', SsAccordion);